

const __assign = (this && this.__assign) || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];
    for (const p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) { t[p] = s[p]; }
    }
  }
  return t;
};
Object.defineProperty(exports, '__esModule', { value: true });
require('es6-promise').polyfill();
require('isomorphic-fetch');

function fetchJSON(url, params) {
    // eslint-disable-next-line no-param-reassign
  params = __assign({}, params, { credentials: 'include', headers: __assign({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }, params.headers) });
  return fetch(url, params);
}
exports.fetchJSON = fetchJSON;
function buildURL(url, data) {
  return url.split('/').map((item) => {
    if (item.indexOf('$') === 0) {
      const key = item.slice(1);
      if (data[key] !== undefined) {
        const value = data[key];
        delete data[key];
        return value;
      }
      return item;
    }
    return item;
  }).join('/');
}
exports.fetchJSONByGet = function (url) {
  return function (query) {
    const params = {
      method: 'GET',
    };
    let getQuery = '?';
    if (query) {
        // eslint-disable-next-line
        for (var name_1 in query) {
          getQuery += `${name_1}=${query[name_1]}&`;
        }
    }
    const buildUrl = buildURL(url, query);
    const getUrl = buildUrl + (query ? getQuery.substring(0, getQuery.length - 1) : '');
    return fetchJSON(getUrl, params);
  };
};
